module.exports = "https://bin.bnbstatic.com/_next/static/images/es6-9f8aa2c738f72a249b13c7f4f85eb096.jpg";